export default class ImageZoom {
    constructor(imgIn, resultIn) {
        let lens;
        let cx;
        let cy;
        let displayWidth;
        let displayHeight;
        const img = $(imgIn);
        const result = $(resultIn);
        /* create lens: */
        if (img.parent().find('.img-zoom-lens').length < 1) {
            lens = document.createElement('DIV');
            lens.setAttribute('class', 'img-zoom-lens');
            /* insert lens: */
            $(lens).insertBefore(img);
            $(lens).css({
                width: `${Math.floor((img.width() / img[0].naturalWidth) * 100)}%`,
                height: `${Math.floor((img.height() / img[0].naturalHeight) * 100)}%`,
            });
            /* calculate the ratio between result DIV and lens: */
            cx = result[0].offsetWidth / lens.offsetWidth;
            cy = result[0].offsetHeight / lens.offsetHeight;
            /* set background properties for the result DIV */
            displayWidth = img[0].naturalWidth;
            displayHeight = img[0].naturalHeight;
            result.css({
                'background-image': `url('${img.attr('src')}')`,
                'background-size': `${displayWidth}px ${displayHeight}px`,
            });
            /* execute a function when someone moves the cursor over the image, or the lens: */
            img.parent().on('click', moveLens);
            img.parent().on('mousemove', moveLens);
            /* and also for touch screens: */
            img.parent().on('touchmove', moveLens);
        }

        function moveLens(e) {
            let x;
            let y;
            /* prevent any other actions that may occur when moving over the image */
            e.preventDefault();
            /* get the cursor's x and y positions: */
            const pos = getCursorPos(e);
            /* calculate the position of the lens: */
            x = pos.x - lens.offsetWidth / 2;
            y = pos.y - lens.offsetHeight / 2;
            /* prevent the lens from being positioned outside the image: */
            if (x > img.width() - lens.offsetWidth) {
                x = img.width() - lens.offsetWidth;
            }
            if (x < 0) {
                x = 0;
            }
            if (y > img.height() - lens.offsetHeight) {
                y = img.height() - lens.offsetHeight;
            }
            if (y < 0) {
                y = 0;
            }
            /* set the position of the lens: */
            $(lens).css('left', `${x}px`);
            $(lens).css('top', `${y}px`);
            /* display what the lens "sees": */
            result.css('background-position', `-${x * cx}px -${y * cy}px`);
        }

        function getCursorPos(e) {
            let x = 0;
            let y = 0;
            /* get the x and y positions of the image: */
            const a = img[0].getBoundingClientRect();
            /* calculate the cursor's x and y coordinates, relative to the image: */
            x = e.pageX - a.left;
            y = e.pageY - a.top;
            /* consider any page scrolling: */
            x -= window.pageXOffset;
            y -= window.pageYOffset;
            return { x, y };
        }
        // }
    }
}
